<template>
  <popup :opened="dataToShow" @close="changeToShow(false)">
    <message-header :message-header="messageHeader" />

    <div class="sticky top-0 z-10">
      <!-- Save button -->
      <save-button
        :saving="saving"
        @save="saveReferent"
        class="right-15 top-15"
      />
    </div>

    <!-- BEGIN Content modal modify referent -->
    <div class="m-5 lg:m-15 2xl:m-20">
      <h3>
        Modifier le compte référent de <br />
        {{ referentToEdit.firstname }}
        <span class="uppercase">{{ referentToEdit.lastname }}</span>
      </h3>
      <div class="w-full flex justify-center my-10">
        <ProfilePicture
          :show-edit-link="true"
          :other-object="referentToEdit"
          size="max-w-36 w-36 h-36"
          @changeProfileImageToAnotherUser="
            (urlPicture) => {
              changeProfileImageToAnotherUser(urlPicture);
            }
          "
        />
      </div>

      <div class="flex justify-center mb-10">
        <div class="border-dashed border-gray-300 border-2 rounded-lg">
          <div class="my-4 mx-8">
            <p class="text-sm italic font-medium text-gray-600">
              Nom d'utilisateur
            </p>
            <h4 class="text-indigo-600">
              {{ referentToEdit.username }}
            </h4>
          </div>
        </div>
      </div>

      <div class="my-10 w-full">
        <div class="grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/10">
          <input-text
            class="lg:col-span-6"
            name="firstname"
            libelle="Prénom"
            :value="referentToEdit.firstname"
            @input="
              (newValue) => {
                referentToEdit.firstname = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.firstname'] || [])[0]"
            :disabled="isAdminPayer"
          />
          <input-text
            class="lg:col-span-6"
            name="lastname"
            libelle="Nom"
            :value="referentToEdit.lastname"
            @input="
              (newValue) => {
                referentToEdit.lastname = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.lastname'] || [])[0]"
            :disabled="isAdminPayer"
          />
          <input-text
            class="lg:col-span-6"
            name="company"
            libelle="Entreprise"
            :value="((referentToEdit.companies || [])[0] || {}).name"
            :disabled="true"
          />
          <input-text
            class="lg:col-span-6"
            name="fonction"
            libelle="Fonction"
            :value="
              (((referentToEdit.companies || [])[0] || {}).pivot || {}).function
            "
            @input="
              (newValue) => {
                (
                  ((referentToEdit.companies || [])[0] || {}).pivot || {}
                ).function = newValue;
              }
            "
            :disabled="isAdminPayer"
          />
          <input-text
            class="lg:col-span-6"
            name="email"
            type="email"
            libelle="Email"
            :value="referentToEdit.email"
            @input="
              (newValue) => {
                referentToEdit.email = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.email'] || [])[0]"
            :disabled="isAdminPayer || isAdminEntreprise"
          />
          <input-text
            class="lg:col-span-6"
            name="phone_number"
            libelle="Téléphone"
            :value="referentToEdit.telephone"
            @input="
              (newValue) => {
                referentToEdit.telephone = newValue;
              }
            "
            :disabled="isAdminPayer"
            :error="true"
            type="tel"
          />
          <div class="col-span-full lg:col-span-6">
            <input-select
              name="role"
              libelle="Rôle par défaut"
              :value="role"
              @input="
                (newValue) => {
                  changeRole(newValue);
                }
              "
              :datas="list_roles"
              :error="true"
              :msg-error="((errors || [])['user.role'] || [])[0]"
              :disabled="isAdminPayer"
            />
            <div v-if="isDisplayConfirmChangeRole" class="text-sm text-red-500">
              <p>
                Attention, sans modifications de votre part, les rôles liés aux
                bénéficiaires rattachés à
                {{ referentToEdit.firstname + ' ' + referentToEdit.lastname }}
                resteront inchangés.
              </p>
            </div>
          </div>
          <input-text-area
            class="lg:col-span-full"
            name="address"
            libelle="Adresse postale"
            :value="referentToEdit.address"
            @input="
              (newValue) => {
                referentToEdit.address = newValue;
              }
            "
            :disabled="isAdminPayer"
          />
        </div>
      </div>
    </div>
    <!-- END Content modal modify referent -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import MessageHeader from './../../../components/MessageHeader';
import Icon from './../../../components/Icon';
import InputText from './../../../components/Inputs/InputText';
import InputSelect from './../../../components/Inputs/InputSelect';
import InputTextArea from './../../../components/Inputs/InputTextArea';
import SaveButton from './../../../components/SaveButton.vue';

import Constants from './../../../constants';
import ProfilePicture from './../../../components/ProfilePicture.vue';

export default {
  name: 'EditReferentPopup',

  props: {
    dataToShow: Boolean,
    isAdminPayer: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAdminEntreprise: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      constants: Constants,
      isDisplayConfirmChangeRole: false,
      newRoleAwaitingConfirmation: '',
    };
  },

  components: {
    ProfilePicture,
    Popup,
    MessageHeader,
    Icon,
    InputText,
    InputSelect,
    InputTextArea,
    SaveButton,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      messageHeader: 'permissions/messageHeader',
      referentToEdit: 'referents/referentToEdit',
      errors: 'referents/errors',
      roles: 'roles/roles',
      referents: 'referents/referents',
      structure: 'auth/structure',
    }),

    list_roles: function () {
      let list = [];

      list.push({ value: Constants.ROLE_ADMIN_PAYEUR });
      list.push({ value: Constants.ROLE_ADMIN_ENTREPRISE });

      const namesToExclude = [
        Constants.ROLE_ADMIN_PAYEUR,
        Constants.ROLE_ADMIN_ENTREPRISE,
        Constants.ROLE_BENEFICIAIRE,
      ];

      this.roles.forEach((role) => {
        if (namesToExclude.includes(role.display_name)) {
          return;
        }
        list.push({ value: role.display_name });
      });

      return list;
    },

    role: {
      get: function () {
        return this.referentToEdit.roles[0].display_name;
      },

      set: function (roleName) {
        const roles = this.roles.filter((role) => {
          return role.display_name === roleName;
        });

        if (roles.length === 1) {
          this.referentToEdit.roles = [roles[0]];
        } else if (roles.length > 1) {
          throw new Error('Multiple roles found');
        } else {
          throw new Error('No role found');
        }
      },
    },
  },

  methods: {
    ...mapActions({
      saveReferent: 'referents/saveReferent',
    }),

    ...mapMutations({
      SET_ERRORS: 'referents/SET_ERRORS',
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    changeToShow(val) {
      this.$emit('showChange', val);
      this.SET_ERRORS(null);
      this.SET_SAVING(false);
      this.newRoleAwaitingConfirmation = '';
      this.isDisplayConfirmChangeRole = false;
    },

    async changeRole(role) {
      let currentRole = this.role;

      if (currentRole === role) {
        return;
      }

      this.role = role;

      if (
        this.referentToEdit.referent_has_current_role_on_attached_beneficiary
      ) {
        this.isDisplayConfirmChangeRole = true;
      }
    },

    confirmChangeRole(confirm) {
      if (confirm) {
        this.role = this.newRoleAwaitingConfirmation;
      }

      this.newRoleAwaitingConfirmation = '';
      this.isDisplayConfirmChangeRole = false;
    },

    changeProfileImageToAnotherUser(urlPicture) {
      this.referentToEdit.profile_image = urlPicture;
      this.saveReferent();
    },
  },
};
</script>
